import React from 'react';
import { Route, BrowserRouter, Redirect } from 'react-router-dom';
import Login from './public/Login/Login';
import Settings from './private/Settings/Settings';
import Dashboard from './private/Dashboard/Dashboard';
import Orders from './private/Orders/Orders';
import Monitors from './private/Monitors/Monitors';
import OrderTemplates from './private/OrderTemplates/OrderTemplates';
import NewOrderTemplate from './private/OrderTemplates/NewOrderTemplate';
import WithdrawTemplates from './private/WithdrawTemplates/WithdrawTemplates';
import Reports from './private/Reports/Reports';
import Symbols from './private/Symbols/Symbols';
import Wallet from './private/Wallet/Wallet';
import WebHooks from './private/WebHooks/WebHooks';
import Bots from './private/Bots/Bots';
import BotPerformance from './private/Bots/BotPerformance';
import Backtest from './private/Backtest/Backtest';
import NewOrder from './private/Futures/NewOrder';
import UnifiedSetup from './private/UnifiedSetup/UnifiedSetup';
import GridBot from './private/GridBot/GridBot';
import ScheduledBot from './private/ScheduledBot/ScheduledBot';
import Home from './public';

import Learn from './public/Learn';
import LearnGuidePage from './public/Learn/LearnGuidePage';
import Company from './public/Company';
import MarketPlace from './public/MarketPlace';
import Solution from './public/Solution';
import Pricing from './public/Pricing';
import Signup from './public/Signup/Signup';
import Subscription from './private/Subscription/Subscription';
import ContactPage from './public/contact/Contact';
import PrivacyPolicy from './public/PrivacyPolicy/PrivacyPolicy';
import CookiePolicy from './public/CookiePolicy/CookiePolicy';
import TermsAndConditions from './public/TermsAndConditions/TermsAndConditions';
import ForgotPassword from './public/ForgotPassword/ForgotPassword';
import ResetPassword from './public/ForgotPassword/ResetPassword';
import ToastHost from './components/Toast/ToastHost';

function Routes() {

    function PrivateRoute({ children, ...rest }) {
        return (
            <Route {...rest} render={() => {
                return localStorage.getItem("token")
                    ? (
                        <>
                            <ToastHost />
                            {children}
                        </>
                    )
                    : <Redirect to='/' />
            }} />
        )
    }

    return (
        <BrowserRouter>
            <Route path="/subscription">
                <Subscription />
            </Route>
            <Route path="/contact">
                <ContactPage />
            </Route>
            <Route path="/privacy-policy" exact>
                <PrivacyPolicy />
            </Route>
            <Route path="/cookie-policy" exact>
                <CookiePolicy />
            </Route>
            <Route path="/terms-and-conditions" exact>
                <TermsAndConditions />
            </Route>
            <Route path="/" exact>
                <Home />
            </Route>
            <Route path="/login" exact>
                <Login />
            </Route>
            <Route path="/register" exact>
                <Signup />
            </Route>
            <Route path="/forgot-password" exact>
                <ForgotPassword />
            </Route>
            <Route path="/reset-password" exact>
                <ResetPassword />
            </Route>
            <Route path="/why-neuratrader" exact>
                <Redirect to="/" />
            </Route>
            <Route path="/learn" exact>
                <Learn />
            </Route>
            <Route path="/learn/:guideId" exact>
                <LearnGuidePage />
            </Route>
            <Route path="/about" exact>
                <Company />
            </Route>
            <Route path="/market-place" exact>
                <MarketPlace />
            </Route>
            <Route path="/solutions" exact>
                <Solution />
            </Route>
            <Route path="/pricing" exact>
                <Pricing />
            </Route>
            <PrivateRoute path="/settings">
                <Settings />
            </PrivateRoute>
            <PrivateRoute path="/(forders|orders)/:symbol?">
                <Orders />
            </PrivateRoute>
            <PrivateRoute path="/dashboard">
                <Dashboard />
            </PrivateRoute>
            <PrivateRoute path="/monitors">
                <Monitors />
            </PrivateRoute>
            <PrivateRoute path="/bots/:sourceType/:sourceId/performance">
                <BotPerformance />
            </PrivateRoute>
            <PrivateRoute path="/bots">
                <Bots />
            </PrivateRoute>
            <PrivateRoute path="/automations">
                <Redirect to="/bots" />
            </PrivateRoute>
            <PrivateRoute path="/unified-setup">
                <UnifiedSetup />
            </PrivateRoute>
            <PrivateRoute path="/grid">
                <GridBot />
            </PrivateRoute>
            <PrivateRoute path="/scheduled">
                <ScheduledBot />
            </PrivateRoute>
            <PrivateRoute path="/(freports|reports)/">
                <Reports />
            </PrivateRoute>
            <PrivateRoute path="/backtest">
                <Backtest />
            </PrivateRoute>
            <PrivateRoute path="/symbols">
                <Symbols />
            </PrivateRoute>
            <PrivateRoute path="/(orderTemplates|fOrderTemplates)/:symbol?">
                <OrderTemplates />
            </PrivateRoute>
            <PrivateRoute path="/orderTemplate/:orderTemplateId?">
                <NewOrderTemplate />
            </PrivateRoute>
            <PrivateRoute path="/withdrawTemplates/:coin?">
                <WithdrawTemplates />
            </PrivateRoute>
            <PrivateRoute path="/wallet">
                <Wallet />
            </PrivateRoute>
            <PrivateRoute path="/webhooks">
                <WebHooks />
            </PrivateRoute>
            <PrivateRoute path="/strategies">
                <Redirect to="/bots" />
            </PrivateRoute>
            <PrivateRoute path="/futures">
                <NewOrder />
            </PrivateRoute>
        </BrowserRouter>
    )
}

export default Routes;